<template>
    <div class="padding-content white-content mb-4">
        <div class="h2 mb-1"> <span>{{ $t('general.abono') }} {{ index }}</span></div>
        <div class="h5 mb-4 regular" v-if="abono.asiento && abono.asiento.zona_nombre">{{ abono.asiento.zona_nombre }} / {{ $t('general.fila') }}: {{ abono.asiento.fila }} / {{ $t('general.butaca') }} {{ abono.asiento.asiento }}</div>
        <div class="h5 mb-4 regular" v-if="abono.tipo_abono">{{ abono.tipo_abono.descripcion}}</div>
        <div class="row">
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput :label="$t('formularios.nombre')" :name="'nombre' + index" rules="required" v-model="abono.nombre" :disabled="bloquear_nombre_y_apellidos_en_renovacion" :style="bloquear_nombre_y_apellidos_en_renovacion ? 'text-decoration: line-through; color: grey;' : ''"/>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput :label="$t('formularios.apellidos')" :name="'apellidos' + index" rules="required" v-model="abono.apellidos" :disabled="bloquear_nombre_y_apellidos_en_renovacion" :style="bloquear_nombre_y_apellidos_en_renovacion ? 'text-decoration: line-through; color: grey;' : ''"/>
            </div>

            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group">
                    <label>{{ $t('formularios.genero') }}</label>
                    <ValidationProvider :name="'genero' + index" rules="required" v-slot="{ errors }">
                        <multiselect
                            :class="(errors[0] ? 'is-invalid' : '')"
                            v-model="abono.genero"
                            :placeholder="$t('formularios.genero')"
                            label="name"
                            track-by="id"
                            :options="generos"
                            @select="(option, id) => abono.genero_id = id"
                        ></multiselect>
                        <span v-if="errors[0]" class="error invalid-feedback" style="display: block;">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>

            <div class="col-12 col-md-6 col-lg-4">
                <FormInput :label="$t('formularios.dni')" :name="'dni' + index" rules="required" v-model="abono.dni" />
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group">
                    <label for="fecha_nacimiento">{{ $t('formularios.nacimiento') }}</label>
                    <ValidationProvider :name="'decha_nacimiento' + index" rules="required" v-slot="{ errors }">
                        <datetime
                            v-model="abono.fecha_nacimiento"
                            :input-class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                            type="date"
                            input-id="fecha_nacimiento"
                            :max-datetime="maxDate"
                            min-datetime="1900-01-01"
                        ></datetime>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput :label="$t('formularios.email')" :name="'email' + index" rules="required" v-model="abono.email" />
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput :label="$t('formularios.telefono')" :name="'telefono' + index" rules="required" v-model="abono.telefono" />
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group">
                    <Paises :errors="errors" v-on:selected="opt => { pais = opt; abono.pais = opt.nombre; }"/>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group">
                    <Provincias :errors="errors" :pais="pais.id" v-on:selected="opt => { provincia = opt; abono.provincia = opt.nombre; }"/>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group">
                    <Locations :provincia="provincia" :errors="errors" v-on:selected="opt => { abono.localidad = opt.nombre; }"/>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput :label="$t('formularios.domicilio')" :name="'domicilio' + index" rules="required" v-model="abono.domicilio" />
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput :label="$t('formularios.cp')" :name="'cp' + index" minlength="5" maxlength="10" rules="required" v-model="abono.cp" />
            </div>
            <div v-if="mostrar_iban == true" class="col-12 col-md-6 col-lg-4">
                <FormInput :label="$t('formularios.iban')" :name="'iban' + index" rules="required" v-model="abono.iban" />
            </div>
            <div v-if="mostrar_titular_cuenta == true" class="col-12 col-md-6 col-lg-4">
                <FormInput :label="$t('formularios.titular_cuenta')" :name="'titular_cuenta' + index" rules="required" v-model="abono.titular_cuenta" />
            </div>
            <div class="col-12 col-md-6 col-lg-12" v-if="mostrar_tipo_abonos">
                <div class="form-group">
                    <div class="d-flex">
                        <label class="mr-2" for="descuento">{{ $t('formularios.tipo_abono') }}</label>
                        <label for="descuento" v-if="this.$store.getters.getTeatro.texto_extra_en_compra_de_abono">{{ this.$store.getters.getTeatro.texto_extra_en_compra_de_abono }}</label>
                    </div>
                    <ValidationProvider :name="'descuento' + index" rules="required" v-slot="{ errors }">
                        <multiselect
                            :class="(errors[0] ? 'is-invalid' : '')"
                            v-model="abono.tipo_abono"
                            :placeholder="$t('formularios.tipo_abono')"
                            label="descripcion"
                            track-by="id"
                            :options="getTiposPrecios(abono)"
                            @input="getPrecio"
                        ></multiselect>                        
                        
                        <small v-if="errors[0]" class="text-danger">Seleccione un tipo de abono</small>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-12" v-if="precio && precio.solicitar_documentacion">
                <label>{{ precio.texto_documentacion }}</label>
                <vue-dropzone
                    ref="myVueDropzone"
                    id="dropzone"
                    :options="dropzoneOptions"
                    v-on:vdropzone-success="imagenSubida"
                    v-on:vdropzone-removed-file="imagenBorrada"
                    :useCustomSlot=true
                >
                    <div class="dropzone-custom-content">
                        <h3 class="dropzone-custom-title">{{ $t('formularios.arrastra') }}</h3>
                    </div>
                </vue-dropzone>
            </div>
            <div class="col-12">
                <h5 class="text-danger">{{ error }}</h5>
            </div>
        </div>
    </div>
</template>

<script>
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import Provincias from "../../../common/forms/Provincias";
    import Locations from "../../../common/forms/Locations";
    import Paises from "../../../common/forms/Paises";

    export default {
        props: ['abono', 'generos', 'index', 'descuentos', 'tipos_abonos', 'tipo_abono_id'],
        data() {
            return {
                error: null,
                mostrar_tipo_abonos: false,
                precio: null,
                dropzoneOptions: {},
                maxDate: null,
                errors: [],
                provincia: null,
                pais: { id: 0 },
                mostrar_iban: this.$store.getters.getTeatro.mostrar_iban,
                mostrar_titular_cuenta: this.$store.getters.getTeatro.mostrar_titular_cuenta,
                bloquear_nombre_y_apellidos_en_renovacion: this.abono.n_abonado_antiguo ? this.$store.getters.getTeatro.bloquear_nombre_y_apellidos_en_renovacion : false
            }
        },
        created() {
            this.setMaxDate();
        },
        watch: {
                "abono.fecha_nacimiento"() {
                    this.getPrecio();
                }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            tipos_renovacion() {
                var tipos = [];

                for(var i in this.tipos_abonos) {
                    if(this.tipos_abonos[i].renovacion &&  !this.tipos_abonos[i].exclusivo_penista) {
                        tipos.push(this.tipos_abonos[i]);
                    }
                }

                return tipos;
            },
            tipos_nuevo() {
                var tipos = [];

                for(var i in this.tipos_abonos) {
                    if(this.tipos_abonos[i].renovacion == 0 && !this.tipos_abonos[i].exclusivo_penista) {
                        tipos.push(this.tipos_abonos[i]);
                    }
                }

                return tipos;
            },
            tipos_penista() {
                var tipos = [];

                for(var i in this.tipos_abonos) {
                    if(this.tipos_abonos[i].exclusivo_penista == 1) {
                        tipos.push(this.tipos_abonos[i]);
                    }
                }

                return tipos;
            },
        },
        mounted() {
            if(this.abono.n_abonado_antiguo) {
                if(this.abono.penista && this.tipos_penista.length > 0) {
                    if(this.tipos_penista.length > 1) {
                        this.mostrar_tipo_abonos = true;
                    } else if(this.tipos_penista.length == 1) {
                        this.abono.tipo_abono = this.tipos_penista[0];
                    }
                } else {
                    if(this.tipos_renovacion.length > 1) {
                        this.mostrar_tipo_abonos = true;
                    } else if(this.tipos_renovacion.length == 1) {
                        this.abono.tipo_abono = this.tipos_renovacion[0];
                        this.mostrar_tipo_abonos = false;
                    } else {
                        this.error = 'Esta zona no esta disponible';
                        this.mostrar_tipo_abonos = false;
                    }
                }
            } else {
                if(this.tipos_nuevo.length > 1) {
                    this.mostrar_tipo_abonos = true;
                } else if(this.tipos_nuevo.length == 1) {
                    this.abono.tipo_abono = this.tipos_nuevo[0];
                    this.mostrar_tipo_abonos = false;
                } else {
                    this.error = 'Esta zona no esta disponible';
                    this.mostrar_tipo_abonos = false;
                }
            }
        },
        methods: {
            getTiposPrecios(abono) {
                if(abono.n_abonado_antiguo) {
                    if(abono.penista && this.tipos_penista.length > 0) {
                        return this.tipos_penista;
                    } else {
                        return this.tipos_renovacion;
                    }
                } else {
                    return this.tipos_nuevo;
                }
            },
            setMaxDate() {
                var date = new Date();

                this.maxDate = date.toISOString();
            },
            getPrecio() {
                if(this.abono.fecha_nacimiento && this.abono.tipo_abono) {
                    if(this.abono.asiento) {
                       const params = {
                            filters: {
                                tid: this.configuracion.hash_teatro,
                                zona_id: this.abono.asiento ? this.abono.asiento.zona_id : null
                            },
                            tid: this.configuracion.hash_teatro,
                            fecha_nacimiento: this.abono.fecha_nacimiento,
                            zona_id: this.abono.asiento ? this.abono.asiento.zona_id : null,
                            tipo_abono: this.abono.tipo_abono
                        }

                        this.$store.dispatch(this.config.getVuexAlias('zonas.calcular.precio'), params).then(res => {
                            this.setDropZone();
                            this.precio = res.data;
                            this.abono.precio = res.data;
                        }); 
                    } else {                        
                        var params_2 = {
                            filters: {
                                tid: this.configuracion.hash_teatro,
                                abono_id: this.abono.tipo_abono.id
                            },
                            tid: this.configuracion.hash_teatro,
                            fecha_nacimiento: this.abono.fecha_nacimiento,
                            abono_id: this.abono.tipo_abono.id,
                            datos_comprador: this.abono
                        }

                        this.$store.dispatch(this.config.getVuexAlias('front.abonos.precios.calcular.precio'), params_2).then(res => {
                            this.setDropZone();
                            this.precio = res.data;
                            this.abono.precio = res.data;
                        }); 
                    }                   
                }

            },
            imagenBorrada() {

            },
            imagenSubida(file, response) {
                if(!this.abono.documentaciones) {
                    this.abono.documentaciones = [];
                }

                this.abono.documentaciones.push(response);
            },
            setDropZone() {
                this.dropzoneOptions = {
                    url: this.config.API_BASE + '/f/upload/documento?tid=' + this.configuracion.hash_teatro,
                    thumbnailWidth: 150,
                    maxFilesize: 20,
                    headers: {
                        'Accept': 'application/json'
                    },
                    uploadMultiple: false,
                    maxFiles: 5
                };
            }
        },
        components: {
            Locations,
            Provincias,
            Paises,
            vueDropzone: vue2Dropzone
        }
    }
</script>

<style>
    #paso3 .multiselect__tags {
        background-color: #f1f1f1 !important;
        border-color: #ccc;
    }
</style>
